import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class ProjectsHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            divisions:this.props.divisions, 
            content:this.props.content, 
            
        }
        

    }
     
    componentDidMount()
    {  
        if(this.props.divisions && this.state.loading === 1)
        {
             this.setState({loading:0});     
        }

        const script = document.createElement("script");
        script.src   = base_url+"assets/js/loadSlider.js";  
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
        if (window.loadSlider && this.props.divisions.length > 0) {
        window.loadProductsHome();
        this.setState({loading:0})
        }
        };
         
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

         <div class="section-full p-t50 p-b50 bg-no-repeat bg-black-light" style={{ backgroundImage: 'url(/images/background/bg5.jpg)' }}>
                
                 
            <div class="container">
                <div class="section-head">
                    <div class="section-head text-center">
                        <h2 class="text-uppercase" style={{color: "#fff"}}>Our Division</h2>
                        <div class="wt-separator-outer">
                            <div class="wt-separator style-square has-bg">
                                <span class="separator-left site-bg-primary"></span>
                                <span class="separator-right site-bg-primary"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div class="section-content">
                     
                    <div class="section-content ">
                        <div class="owl-carousel home-carousel-1 mfp-gallery gallery owl-btn-vertical-center m-b30 services-items services-carousel-3-col">
                  
                    {this.state.divisions.map((item, index) => (
                        <div class="item">
                                <div class="flip-container">
                                    <div class="wt-box">
                                        <div class="wt-thum-bx">
                                            <img src={item.home_image} alt={item.title} />	
                                        </div>
                                        <div class="wt-info bg-white text-center bdr-5 bdr-primary">
                                             <img src={item.logo_home} alt={item.title} />		
                                        	<div class="wt-info-text p-a30">
                                            	
												
                                                <h3 class="text-uppercase">{item.title}</h3>
                                                
                                            <Link to={base_url+`divisions/${item.slug}`} class="site-button text-uppercase">Read More</Link>
											</div>
                                         </div>
                            
                            
                        </div>
                        </div>
                        </div>
                    ))}
                       
                    </div>
                </div>
            </div>
        </div>
   
       
    );
}

}

export default ProjectsHome;